import { ILeader } from "./interface";

export const LEADERS: ILeader[] = [

];
